import {ApiClient} from '@hconnect/apiclient'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {TasksApiPath, FEATURE_NAMESPACE} from '../../../consts'
import {OilAnalysisActionDto} from '../../../types'
import {EditOilAnalysisAction} from '../../../types/oil-analysis-actions.types'
import {TasksQueryKey} from '../useTasks'

import {OilAnalysisActionQueryKey} from './useOilAnalysisAction'

export const useUpdateOilAnalysisAction = () => {
  const queryClient = useQueryClient()
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation<OilAnalysisActionDto, AxiosError, EditOilAnalysisAction>({
    mutationFn: async (data) => {
      const {id, plantUpmId} = data
      const path = `${TasksApiPath.OIL_ANALYSIS_ACTIONS}/${plantUpmId}/oil-analysis-actions/${id}`

      const payload = data

      const {data: response} = await ApiClient.axiosInstance.patch<OilAnalysisActionDto>(
        path,
        payload
      )
      return response
    },
    onError: () => {
      spawnErrorToast(t('oilAnalysisActions.message.failedToUpdateOilAnalysisAction'))
    },
    onSuccess: () => {
      spawnSuccessToast(t('oilAnalysisActions.message.oilAnalysisActionUpdated'))
      void queryClient.invalidateQueries({
        queryKey: [OilAnalysisActionQueryKey],
        refetchType: 'all'
      })
      void queryClient.invalidateQueries({queryKey: [TasksQueryKey], refetchType: 'all'})
    }
  })
}
